import { render, staticRenderFns } from "./case-import.vue?vue&type=template&id=c231cdfc&scoped=true"
import script from "./case-import.vue?vue&type=script&lang=ts"
export * from "./case-import.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c231cdfc",
  null
  
)

export default component.exports